module.exports = __webpack_public_path__ + "img/center12.70784a79.png";